<template>
  <div class="account common_register_content">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="85px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <!-- <el-col :xs="24" :sm="24" :md="24">
          <el-form-item :label="name?'公司名称':'您的姓名'" prop="name">
            <el-input type="name" v-model="ruleForm.name" placeholder="请输入您的真实姓名" auto-complete="new-password"></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="登录密码" prop="pwd">
            <el-input type="password" v-model="ruleForm.pwd" maxlength="18" show-password placeholder="请输入登录密码" auto-complete="new-password"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" style="margin-top: 20px">
          <el-form-item label="确认密码" prop="confirmpwd">
            <el-input type="password" v-model="ruleForm.confirmpwd" maxlength="18" show-password placeholder="请确认登录密码" auto-complete="new-password"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label prop="code">
            <el-input type="code" v-model="ruleForm.code" placeholder="请输入您收到的短信验证码">
              <el-button slot="append" @click="getCode()" style="font-size:16px">获取验证码</el-button>
            </el-input>
          </el-form-item>
        </el-col> -->
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label>
            <div class="input_span">
              <span class="input_span1">密码安全程度</span>
              <span id="one" class="input_span1">弱</span>
              <span id="two" class="input_span1">中</span>
              <span id="three" class="input_span1">强</span>
              <a style="cursor: pointer;" @click="centerDialogVisible=true">密码设置建议</a>
            </div>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item class="button">
            <el-button type="danger" style="width:150px;height:40px" @click="finish('ruleForm')">完成</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
        title="密码设置建议"
        :visible.sync="centerDialogVisible"
        width="60%"
        center>
        <p style="padding:10px;text-indent:25px;font-size:20px;">密码是取得您的网络账户数据的钥匙，因此您必须牢记并妥善保管您的密码。密码可以是任何字符，包括数字、字母、特殊字符等。长度在6～18位之间，区分英文字母大小写。建议您的密码尽量是包含字母、数字、特殊字符的组合，且不要设置成常用数字，如生日、电话号码等，也不要设为一个单词。密码的位数应该超过六位，经常修改密码，并为重要服务例如网上出借服务设置独立的密码</p>
      </el-dialog>
  </div>
</template>

<script>
import { checkStrong } from "@/util/validate.js";
import { getStore } from "@/util/store";
import { Register } from "@/api/admin/login.js";
// var validatName = (rule, value, callback) => {
//   if (value === "") {
//     callback(new Error("请输入您的真是姓名哦~"));
//   } else {
//     callback();
//   }
// };
var validatePass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入密码"));
  } else {
    if (String(value).length < 6) {
      callback(new Error("密码不足6位"));
    } else if (String(value).length < 19) {
      callback();
    } else {
      callback(new Error("密码过长"));
    }
  }
};
/*var validatePass = (rule, value, callback) => {
  let reg = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/
  let valid = reg.test(value);
  if (!valid) {
    callback(new Error("密码应不少于8位，且应包含数字、大写字母、小写字母、特殊字符中的至少3种"));
  }else {
    callback();
  }
};*/

// var checkCode = (rule, value, callback) => {
//   if (value === "") {
//     callback(new Error("请输入验证码"));
//   } else {
//     if (String(value).length == 4) {
//       callback();
//     } else {
//       return callback(new Error("请输入四位数验证码"));
//     }
//   }
// };
export default {
  data() {
    var checkPassWord = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入登录密码"));
      } else if (value !== this.ruleForm.pwd) {
        callback(new Error("两次输入密码不一致!"));
      }else{
        callback()
      }
    };
    return {
      ruleForm: {
        // name: "",
        pwd: "",
        code: "",
        mobile: "",
        confirmpwd:""
      },
      submitForm: {},
      centerDialogVisible:false,
      rules: {
        // name: [{ validator: validatName, trigger: "blur" }],
        pwd: [{ required: true,validator: validatePass, trigger: "blur" }],
        // code: [{ validator: checkCode, trigger: "blur" }],
        confirmpwd: [
          { required: true,validator: checkPassWord, trigger: "blur" }
        ]
      },
      msgText: ""
    };
  },
  props: {
    next: Function,
    name: Boolean
  },
  watch: {
    ruleForm: {
      handler(newVal) {
        this.msgText = checkStrong(newVal.pwd);
        if (this.msgText > 1 || this.msgText == 1) {
          document.getElementById("one").style.background = "red";
        } else {
          document.getElementById("one").style.background = "#eee";
        }
        if (this.msgText > 2 || this.msgText == 2) {
          document.getElementById("two").style.background = "orange";
        } else {
          document.getElementById("two").style.background = "#eee";
        }
        if (this.msgText == 4) {
          document.getElementById("three").style.background = "#00D1B2";
        } else {
          document.getElementById("three").style.background = "#eee";
        }
      },
      deep: true
    }
  },
  methods: {
    getCode() {},
    finish(ruleForm) {
      this.submitForm.pwd = this.ruleForm.pwd;
      // this.submitForm.password = this.ruleForm.pwd;
      this.submitForm.confirmpwd = this.ruleForm.confirmpwd
      this.submitForm.mobile = getStore({ name: "mobile" }).mobile;
      this.submitForm.userType = getStore({ name: "register_role" });
      
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          Register(this.submitForm).then(data => {
            
            var list = data.data.result;
            if (list) {
              if (list.isSuccess) {
                this.next();
              }else{
                 this.$message({
                  message: list.errorMsg,
                  type: 'warning'
               });
               this.$router.go(-1)
              }
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less">
.account {
  width: 80%;
  margin: 0 auto;
  .el-input-group__append:hover {
    opacity: 0.7;
  }
  .button {
    text-align: center;
    margin: 50px 0px;
    .el-form-item__content {
      margin-left: 0px !important;
    }
  }
  .input_span {
    position: relative;
    .input_span1 {
      margin-right: 20px;
    }
    span + span {
      display: inline-block;
      width: 40px;
      height: 20px;
      background: #eee;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
    }
    a {
      position: absolute;
      right: 0px;
      color: #ea0000;
    }
  }
  .input_span;
}
</style>